import { useDateFormat } from '@vueuse/core'
import type { OrderItem, WishlistItem } from './types'

export const getErrorMessage = (error: any, customMessage?: string) => {
  if (Array.isArray(error.response?.data?.message)) {
    return error.response.data.message.join(', ')
  }
  return (
    error?.response?.msg ||
    error?.data?.message ||
    error?.data?.msg ||
    error?.response?.data?.message ||
    error?.response?.data?.msg ||
    error?.response?._data?.message ||
    error?.response?._data?.msg ||
    error?.message ||
    customMessage ||
    'Something went wrong'
  )
}

export const formatDate = (date?: string) => {
  if (date) return useDateFormat(date, 'Do MMM, YYYY')
}
export const calculateAmount = (item: OrderItem) => {
  let amount = item.amount
  if (item.trialPeriod) {
    amount = 0
  }
  return amount + (item.setupFee ?? 0)
}
export const getProfitPercent = (item: WishlistItem) => {
  return `${(((item.compareAtPrice - item.amount) * 100) / item.compareAtPrice).toFixed(0)}% off`
}
